import { OPTabInReducer, OPTabRequirementsContext } from '@components/operatorPanel/interfaces';

export const isOPTabVisible = (tab: OPTabInReducer, ctx: OPTabRequirementsContext): boolean => {
  const machineRequirements = tab.requires?.machinePerspective;
  if (!machineRequirements || !ctx.isMachinePerspective) return true;

  return Object.entries(machineRequirements).every(([key, required]) => {
    if (!required) return true;
    return ctx[key as keyof typeof machineRequirements] === true;
  });
};
